  <div class="row mb-4" style="margin-top:65px">
    <div class="col-12 col-md-6">
      <div class="col-12 col-md-9 module_title c_bluedk">
        <i class="fas fa-fw fa-graduation-cap me-2"></i>Welara Academy
      </div>
    </div>
    <div class="col-12 col-md-6 text-end">
      <button class="btn btn-sm btn-dark" (click)="toggleModal('show')" *ngIf="authAdmin == '1'">
        <i class="fas fa-plus me-2"></i>Add Resource
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-4">
      <div class="row mb-2">
        <div class="col-12 col-md-9 section_title c_bluedk">
          <i class="fas fa-fw fa-link me-2"></i>Important Links
        </div>
        <div class="col-12 col-md-3"></div>
      </div>
      <div class="row">
        <div class="col-12">
          <div *ngFor="let link of listLinks">
            <a [href]="link.content_url" target="_blank" class="card-link-sm">
              <i class="fas fa-fw fa-file me-2"></i>{{ link.title }}
            </a>
          </div>
        </div>
      </div>

    </div>
    <div class="col-12 col-lg-4">
      <div class="row mb-2">
        <div class="col-12 col-md-9 section_title c_bluedk">
          <i class="fas fa-fw fa-newspaper me-2"></i>Publications
        </div>
        <div class="col-12 col-md-3"></div>
      </div>
      <div class="row">
        <div class="col-12">
          <div *ngFor="let file of listPublications">
            <a [href]="file.content_url" target="_blank" class="card-link-sm">
              <i class="fas fa-fw fa-file-pdf me-2 c_red"></i>{{ file.title }}
            </a>
          </div>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-12 col-md-9 section_title c_bluedk">
          <i class="fas fa-fw fa-image me-2"></i>Images
        </div>
        <div class="col-12 col-md-3"></div>
      </div>
      <div class="row">
        <div class="col-12">
          <img [src]="file.content_url" [title]="file.title" class="img_academy p-1 m-2 border" *ngFor="let file of listImages" />


        </div>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="row mb-2">
        <div class="col-12 col-md-9 section_title c_bluedk">
          <i class="fas fa-fw fa-video me-2"></i>How-to Videos
        </div>
        <div class="col-12 col-md-3"></div>
      </div>
      <div class="scroller">
        <div *ngFor="let file of listVideos">
          <a [href]="file.content_url" target="_blank" class="card-link-sm">
            <i class="fas fa-fw c_bluedk {{(file.content_type.indexOf('loom') > -1) ? 'fa-play' : 'fa-link'}} me-2"></i>{{ file.title }}
          </a>
          <div class="card-text">{{ file.description }}</div>
          <span class="text-muted c_blue">{{file.tags}}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal for Add -->
  <div class="backdrop" [ngStyle]="{'display':showModal}"></div>
  <div class="modal" tabindex="-1" [ngStyle]="{ 'display': showModal }" id="contentModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title">
            <i class="fas fa-fw fa-plus me-2"></i>Add Resource
          </span>
          <button type="button" class="btn-close" (click)="toggleModal('hide')"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3" *ngIf="errorMsg != ''">
            <div class="alert alert-warning p-2">
              {{errorMsg}}
            </div>
          </div>
          <div class="mb-3">
            <label class="c_blue">URL</label>
            <input type="text" [(ngModel)]="helpAsset.url" class="form-control form-control-sm" />
          </div>
          <div class="mb-3">
            <label class="c_blue">Title</label>
            <input type="text" [(ngModel)]="helpAsset.title" class="form-control form-control-sm" />
          </div>
          <div class="mb-3">
            <label class="c_blue">Description</label>
            <textarea [(ngModel)]="helpAsset.description" class="form-control form-control-sm"></textarea>
          </div>
          <div class="mb-3">
            <label class="c_blue">Content Type</label>
            <select [(ngModel)]="helpAsset.type" class="form-select form-select-sm">
              <option value="image">Image</option>
              <option value="publication">Publication</option>
              <option value="link">Link</option>
              <option value="loom_video">Loom Video</option>
            </select>
          </div>
          <div class="mb-3">
            <label class="c_blue">Tags</label>
            <ng-multiselect-dropdown [placeholder]="'Select Tags'"
                                     [settings]="dropdownSettings"
                                     [data]="listTags"
                                     [(ngModel)]="helpAsset.tags"
                                     (onSelect)="onTagSelect($event)"
                                     
                                     >
            </ng-multiselect-dropdown>
          </div>

          <!-- <div class="mb-3">
            <label>Active</label>
            <select [(ngModel)]="helpAsset.active" class="form-select form-select-sm">
              <option [value]="1">Yes</option>
              <option [value]="0">No</option>
            </select>
          </div> -->
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary btn-sm" (click)="saveAcademyAsset()"><i class="fas fa-fw fa-save me-2"></i>Save</button>
          <button class="btn btn-secondary btn-sm" (click)="toggleModal('hide')"><i class="fas fa-fw fa-times me-2"></i>Cancel</button>
        </div>
      </div>
    </div>
  </div>
